import React, { useState } from 'react';

const Deploy = () => {
  const [activeTab, setActiveTab] = useState('custom');

  return (
    <div style={{
      minHeight: '100vh',
      background: '#000000',
      color: '#ffffff',
      padding: '40px 20px'
    }}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        
        <h1 style={{
          fontSize: '1.5rem',
          fontWeight: '600',
          marginBottom: '8px',
          color: '#dc2626'
        }}>
          Deploy Agents to NANDA
        </h1>
        <p style={{
          fontSize: '0.875rem',
          color: '#999',
          marginBottom: '30px'
        }}>
          Deploy custom agents or use pre-configured templates
        </p>

        {/* Tab Selection */}
        <div style={{ display: 'flex', gap: '12px', marginBottom: '30px', flexWrap: 'wrap' }}>
          <button
            onClick={() => setActiveTab('custom')}
            style={{
              padding: '10px 16px',
              background: activeTab === 'custom' ? '#dc2626' : '#111',
              border: '1px solid ' + (activeTab === 'custom' ? '#dc2626' : '#333'),
              borderRadius: '4px',
              color: '#fff',
              fontSize: '0.813rem',
              cursor: 'pointer'
            }}
          >
            I Have a Custom Agent
          </button>
          <button
            onClick={() => setActiveTab('new')}
            style={{
              padding: '10px 16px',
              background: activeTab === 'new' ? '#dc2626' : '#111',
              border: '1px solid ' + (activeTab === 'new' ? '#dc2626' : '#333'),
              borderRadius: '4px',
              color: '#fff',
              fontSize: '0.813rem',
              cursor: 'pointer'
            }}
          >
            Deploy to AWS Cloud
          </button>
          <button
            onClick={() => setActiveTab('build')}
            style={{
              padding: '10px 16px',
              background: activeTab === 'build' ? '#dc2626' : '#111',
              border: '1px solid ' + (activeTab === 'build' ? '#dc2626' : '#333'),
              borderRadius: '4px',
              color: '#fff',
              fontSize: '0.813rem',
              cursor: 'pointer'
            }}
          >
            Build & Test Locally
          </button>
        </div>

        {/* TAB 1: CUSTOM AGENT PATH */}
        {activeTab === 'custom' && (
          <>
            <section style={{ marginBottom: '30px' }}>
              <h2 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#fff', marginBottom: '12px' }}>
                Step 1: Agent Requirements
              </h2>
              
              <p style={{ fontSize: '0.813rem', color: '#ccc', marginBottom: '12px' }}>
                Your agent must have:
              </p>
              
              <ul style={{ fontSize: '0.813rem', color: '#ccc', marginBottom: '16px', paddingLeft: '20px' }}>
                <li style={{ marginBottom: '6px' }}>
                  <strong>A2A Endpoint:</strong> <code style={{ background: '#111', padding: '2px 4px', color: '#dc2626' }}>POST /a2a</code> for agent-to-agent communication
                </li>
                <li style={{ marginBottom: '6px' }}>
                  <strong>Public URL:</strong> Deployed on cloud (Vercel, Railway, AWS) or using ngrok
                </li>
              </ul>

              <p style={{ fontSize: '0.75rem', fontWeight: '600', color: '#fff', marginBottom: '6px' }}>
                A2A Endpoint Format:
              </p>
              <pre style={{
                background: '#111',
                padding: '12px',
                borderRadius: '4px',
                overflow: 'auto',
                fontSize: '0.688rem',
                color: '#ccc',
                fontFamily: 'monospace',
                lineHeight: '1.4',
                marginBottom: '16px'
              }}>
{`{
  "role": "user",
  "content": {
    "type": "text",
    "text": "Your message or @agent-id"
  },
  "conversation_id": "unique-id",
  "message_id": "unique-id"
}`}
              </pre>

              <p style={{ fontSize: '0.75rem', fontWeight: '600', color: '#fff', marginBottom: '8px' }}>
                Compatible Frameworks:
              </p>
              <p style={{ fontSize: '0.813rem', color: '#ccc', marginBottom: '16px' }}>
                CrewAI, LangChain, LangGraph, AutoGen, Flask/FastAPI, any framework
              </p>
            </section>

            <section style={{ marginBottom: '30px' }}>
              <h2 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#fff', marginBottom: '12px' }}>
                Step 2: Prepare AgentFacts
              </h2>

              <p style={{ fontSize: '0.813rem', color: '#ccc', marginBottom: '12px' }}>
                AgentFacts is a JSON profile describing your agent's capabilities. You must create and host this file at a public URL.
              </p>

              <pre style={{
                background: '#111',
                padding: '12px',
                borderRadius: '4px',
                overflow: 'auto',
                fontSize: '0.688rem',
                color: '#ccc',
                fontFamily: 'monospace',
                lineHeight: '1.4',
                marginBottom: '16px',
                maxHeight: '300px'
              }}>
{`{
  "agent_name": "my-agent",
  "label": "My Custom Agent",
  "description": "Agent description",
  "version": "1.0",
  "provider": {
    "name": "Your Organization",
    "url": "https://yourwebsite.com"
  },
  "skills": [
    {
      "id": "skill-1",
      "description": "Data analysis",
      "inputModes": ["text"],
      "outputModes": ["text"]
    }
  ],
  "capabilities": {
    "modalities": ["text"],
    "streaming": false
  }
}`}
              </pre>
            </section>

            <section style={{ marginBottom: '30px' }}>
              <h2 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#fff', marginBottom: '12px' }}>
                Step 3: Register Your Agent
              </h2>

              <p style={{ fontSize: '0.813rem', color: '#ccc', marginBottom: '12px' }}>
                Option A: <a href="/agents/add" style={{ color: '#dc2626', textDecoration: 'underline' }}>Web Form</a>
              </p>

              <p style={{ fontSize: '0.813rem', color: '#ccc', marginBottom: '8px' }}>
                Option B: API Endpoint
              </p>
              <pre style={{
                background: '#111',
                padding: '12px',
                borderRadius: '4px',
                overflow: 'auto',
                fontSize: '0.688rem',
                color: '#ccc',
                fontFamily: 'monospace',
                lineHeight: '1.4'
              }}>
{`curl -X POST https://nest.projectnanda.org/api/agents \\
  -H "Content-Type: application/json" \\
  -d '{
    "agent_id": "my-agent",
    "name": "My Custom Agent",
    "endpoint": "https://my-agent.example.com:8000",
    "facts_url": "https://list39.org/@myagent.json",
    "description": "Agent description",
    "specialization": "Domain",
    "capabilities": ["skill1", "skill2"],
    "agent_type": "skill",
    "status": "running"
  }'`}
              </pre>
            </section>
          </>
        )}

        {/* TAB 2: DEPLOY NEW AGENT PATH */}
        {activeTab === 'new' && (
          <>
            <section style={{ marginBottom: '30px' }}>
              <h2 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#fff', marginBottom: '12px' }}>
                Deploy Using NEST Framework
              </h2>

              <p style={{ fontSize: '0.813rem', color: '#ccc', marginBottom: '16px' }}>
                NEST deployment scripts automatically create EC2 instance, install dependencies, configure A2A endpoints, register with NANDA, and set up monitoring.
              </p>

              <p style={{ fontSize: '0.875rem', fontWeight: '600', color: '#fff', marginBottom: '8px' }}>
                Single Agent Deployment:
              </p>
              <pre style={{
                background: '#111',
                padding: '12px',
                borderRadius: '4px',
                overflow: 'auto',
                fontSize: '0.688rem',
                color: '#ccc',
                fontFamily: 'monospace',
                lineHeight: '1.4',
                marginBottom: '20px'
              }}>
{`bash scripts/aws-single-agent-deployment.sh \\
  "agent-id" \\
  "your-api-key" \\
  "Agent Name" \\
  "domain" \\
  "specialization" \\
  "description" \\
  "capabilities" \\
  "smithery-api-key" \\
  "registry-url" \\
  "mcp-registry-url" \\
  "port" \\
  "region" \\
  "instance-type"`}
              </pre>

              <p style={{ fontSize: '0.875rem', fontWeight: '600', color: '#fff', marginBottom: '8px' }}>
                Multi-Agent Deployment:
              </p>
              <pre style={{
                background: '#111',
                padding: '12px',
                borderRadius: '4px',
                overflow: 'auto',
                fontSize: '0.688rem',
                color: '#ccc',
                fontFamily: 'monospace',
                lineHeight: '1.4',
                marginBottom: '20px'
              }}>
{`bash scripts/aws-multi-agent-deployment.sh \\
  "your-api-key" \\
  "scripts/agent_configs/group-01.json" \\
  "smithery-key" \\
  "http://registry.example.com:6900" \\
  "https://mcp-registry.ngrok-free.app" \\
  "us-east-1" \\
  "t3.xlarge"`}
              </pre>
            </section>

            <section style={{ marginBottom: '30px' }}>
              <h2 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#fff', marginBottom: '12px' }}>
                Example
              </h2>

              <pre style={{
                background: '#111',
                padding: '12px',
                borderRadius: '4px',
                overflow: 'auto',
                fontSize: '0.688rem',
                color: '#ccc',
                fontFamily: 'monospace',
                lineHeight: '1.4',
                marginBottom: '12px'
              }}>
{`bash scripts/aws-single-agent-deployment.sh \\
  "furniture-expert" \\
  "sk-ant-api03-..." \\
  "Furniture Expert" \\
  "furniture and interior design" \\
  "knowledgeable furniture specialist" \\
  "I help with furniture selection" \\
  "furniture,interior design" \\
  "smithery-key-xxxxx" \\
  "http://registry.example.com:6900" \\
  "https://mcp-registry.ngrok-free.app" \\
  "6000" \\
  "us-east-1" \\
  "t3.micro"`}
              </pre>

              <p style={{ fontSize: '0.75rem', fontWeight: '600', color: '#fff', marginBottom: '6px' }}>
                What Gets Created:
              </p>
              <ul style={{ fontSize: '0.813rem', color: '#ccc', paddingLeft: '20px' }}>
                <li>EC2 Instance with Python 3.8+</li>
                <li>Agent Server at http://[public-ip]:[port]</li>
                <li>A2A Endpoint at /a2a</li>
                <li>Health Checks</li>
                <li>Registry Entry</li>
              </ul>
            </section>

            <section style={{ marginBottom: '30px' }}>
              <h2 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#fff', marginBottom: '12px' }}>
                Available Agent Groups
              </h2>

              <p style={{ fontSize: '0.813rem', color: '#ccc', marginBottom: '12px' }}>
                Pre-configured groups: Business & Finance, Technology & Engineering, Creative & Design, Healthcare & Life Sciences, Education & Research, Media & Entertainment, Environmental & Sustainability, Social Services, Sports & Recreation, Travel & Hospitality
              </p>

              <p style={{ fontSize: '0.813rem', color: '#ccc' }}>
                Full documentation: <a 
                  href="https://github.com/projnanda/NEST" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{ color: '#dc2626', textDecoration: 'underline' }}
                >
                  NEST GitHub Repository
                </a>
              </p>
            </section>
          </>
        )}

        {/* TAB 3: BUILD & TEST LOCALLY */}
        {activeTab === 'build' && (
          <>
            <section style={{ marginBottom: '30px' }}>
              <h2 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#fff', marginBottom: '12px' }}>
                Why Build Locally?
              </h2>

              <p style={{ fontSize: '0.813rem', color: '#ccc', marginBottom: '12px' }}>
                Perfect for development, testing, and prototyping. Develop on your local machine, test agent logic, iterate quickly without cloud costs, and learn how NANDA works.
              </p>

              <p style={{ fontSize: '0.875rem', fontWeight: '600', color: '#fff', marginBottom: '8px' }}>
                Setup:
              </p>
              <pre style={{
                background: '#111',
                padding: '12px',
                borderRadius: '4px',
                overflow: 'auto',
                fontSize: '0.688rem',
                color: '#ccc',
                fontFamily: 'monospace',
                lineHeight: '1.4',
                marginBottom: '20px'
              }}>
{`pip install python-a2a anthropic openai flask python-dotenv
brew install ngrok
ngrok authtoken YOUR_TOKEN`}
              </pre>
            </section>

            <section style={{ marginBottom: '30px' }}>
              <h2 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#fff', marginBottom: '12px' }}>
                Templates
              </h2>

              <p style={{ fontSize: '0.813rem', color: '#ccc', marginBottom: '16px' }}>
                Start with a template and customize the agent_logic() function. Framework handles A2A endpoints and registration automatically.
              </p>

              <div style={{ marginBottom: '16px' }}>
                <p style={{ fontSize: '0.875rem', fontWeight: '600', color: '#fff', marginBottom: '8px' }}>
                  Template 1: Echo Agent
                </p>
                <p style={{ fontSize: '0.75rem', color: '#999', marginBottom: '8px' }}>
                  Rule-based, no LLM required
                </p>
                <pre style={{
                  background: '#111',
                  padding: '12px',
                  borderRadius: '4px',
                  overflow: 'auto',
                  fontSize: '0.625rem',
                  color: '#ccc',
                  fontFamily: 'monospace',
                  lineHeight: '1.4',
                  maxHeight: '300px',
                  border: '1px solid #222'
                }}>
{`#!/usr/bin/env python3
import os
from dotenv import load_dotenv
from nanda_core import NANDA
from pyngrok import ngrok

load_dotenv()

# ============================================
# CUSTOMIZE THIS FUNCTION FOR YOUR AGENT
# ============================================
def agent_logic(message: str, conversation_id: str) -> str:
    """
    Your agent's brain - customize this function only.
    
    Args:
        message: User's input text
        conversation_id: Unique conversation identifier
        
    Returns:
        str: Your agent's response
    """
    msg = message.lower()
    
    # Add your custom logic here
    if "hello" in msg or "hi" in msg:
        return f"Hello! I'm {os.getenv('AGENT_ID')}. How can I help?"
    elif "help" in msg:
        return "I can respond to greetings and questions. Try asking me something!"
    elif "?" in message:
        return f"Great question! Let me think... {message}"
    else:
        return f"You said: {message}. (Echo mode)"

# ============================================
# DO NOT MODIFY BELOW (NEST Infrastructure)
# ============================================
if __name__ == "__main__":
    port = int(os.getenv("PORT", "7000"))
    
    # Setup ngrok tunnel
    if os.getenv("ENABLE_TUNNEL", "false").lower() == "true":
        ngrok.set_auth_token(os.getenv("NGROK_AUTH_TOKEN"))
        tunnel = ngrok.connect(port, bind_tls=True)
        public_url = tunnel.public_url
        print(f"🌐 Tunnel URL: {public_url}")
    else:
        public_url = os.getenv("PUBLIC_URL", f"http://localhost:{port}")
    
    # Initialize NANDA agent
    nanda = NANDA(
        agent_id=os.getenv("AGENT_ID"),
        agent_logic=agent_logic,
        port=port,
        public_url=public_url,
        registry_url=os.getenv("REGISTRY_URL"),
        enable_telemetry=True
    )
    
    print(f"🤖 Agent '{os.getenv('AGENT_ID')}' ready!")
    print(f"📡 Listening on port {port}")
    
    # Start the agent server
    nanda.start()`}
                </pre>
              </div>

              <div style={{ marginBottom: '16px' }}>
                <p style={{ fontSize: '0.875rem', fontWeight: '600', color: '#fff', marginBottom: '8px' }}>
                  Template 2: LLM Agent
                </p>
                <p style={{ fontSize: '0.75rem', color: '#999', marginBottom: '8px' }}>
                  Powered by Claude/GPT, production-ready
                </p>
                <pre style={{
                  background: '#111',
                  padding: '12px',
                  borderRadius: '4px',
                  overflow: 'auto',
                  fontSize: '0.625rem',
                  color: '#ccc',
                  fontFamily: 'monospace',
                  lineHeight: '1.4',
                  maxHeight: '300px',
                  border: '1px solid #222'
                }}>
{`#!/usr/bin/env python3
import os
from dotenv import load_dotenv
from nanda_core import NANDA
from pyngrok import ngrok
# Choose your LLM client:
from anthropic import Anthropic  # or: from openai import OpenAI

load_dotenv()

# Initialize LLM client
llm_client = Anthropic(api_key=os.getenv("ANTHROPIC_API_KEY"))
# For OpenAI: llm_client = OpenAI(api_key=os.getenv("OPENAI_API_KEY"))

# ============================================
# CUSTOMIZE THIS FUNCTION FOR YOUR AGENT
# ============================================
def agent_logic(message: str, conversation_id: str) -> str:
    """
    LLM-powered agent - customize the system prompt and model.
    """
    
    # CUSTOMIZE: Your agent's personality and instructions
    system_prompt = f"""You are {os.getenv('AGENT_ID')}, a helpful AI assistant.
Your specialization: {os.getenv('AGENT_SPECIALIZATION', 'general assistance')}
Your capabilities: {os.getenv('AGENT_CAPABILITIES', 'conversation')}

Be concise, friendly, and helpful in your responses."""
    
    try:
        # Call LLM (Claude example)
        response = llm_client.messages.create(
            model="claude-3-5-sonnet-20241022",
            max_tokens=1024,
            system=system_prompt,
            messages=[{"role": "user", "content": message}]
        )
        return response.content[0].text
        
        # For OpenAI/GPT:
        # response = llm_client.chat.completions.create(
        #     model="gpt-4",
        #     messages=[
        #         {"role": "system", "content": system_prompt},
        #         {"role": "user", "content": message}
        #     ]
        # )
        # return response.choices[0].message.content
        
    except Exception as e:
        return f"Error processing request: {str(e)}"

# ============================================
# DO NOT MODIFY BELOW (NEST Infrastructure)
# ============================================
if __name__ == "__main__":
    port = int(os.getenv("PORT", "7000"))
    
    # Setup ngrok tunnel
    if os.getenv("ENABLE_TUNNEL", "false").lower() == "true":
        ngrok.set_auth_token(os.getenv("NGROK_AUTH_TOKEN"))
        tunnel = ngrok.connect(port, bind_tls=True)
        public_url = tunnel.public_url
        print(f"🌐 Tunnel URL: {public_url}")
    else:
        public_url = os.getenv("PUBLIC_URL", f"http://localhost:{port}")
    
    nanda = NANDA(
        agent_id=os.getenv("AGENT_ID"),
        agent_logic=agent_logic,
        port=port,
        public_url=public_url,
        registry_url=os.getenv("REGISTRY_URL"),
        enable_telemetry=True
    )
    
    print(f"🤖 LLM Agent '{os.getenv('AGENT_ID')}' ready!")
    nanda.start()`}
                </pre>
              </div>

              <div style={{ marginBottom: '16px' }}>
                <p style={{ fontSize: '0.875rem', fontWeight: '600', color: '#fff', marginBottom: '8px' }}>
                  Template 3: Stateful Agent
                </p>
                <p style={{ fontSize: '0.75rem', color: '#999', marginBottom: '8px' }}>
                  Maintains conversation history
                </p>
                <pre style={{
                  background: '#111',
                  padding: '12px',
                  borderRadius: '4px',
                  overflow: 'auto',
                  fontSize: '0.625rem',
                  color: '#ccc',
                  fontFamily: 'monospace',
                  lineHeight: '1.4',
                  maxHeight: '300px',
                  border: '1px solid #222'
                }}>
{`#!/usr/bin/env python3
import os
from dotenv import load_dotenv
from nanda_core import NANDA
from pyngrok import ngrok

load_dotenv()

# Conversation memory storage
conversation_history = {}

# ============================================
# CUSTOMIZE THIS FUNCTION FOR YOUR AGENT
# ============================================
def agent_logic(message: str, conversation_id: str) -> str:
    """
    Stateful agent that remembers conversation context.
    """
    
    # Initialize conversation history
    if conversation_id not in conversation_history:
        conversation_history[conversation_id] = []
    
    # Add current message to history
    conversation_history[conversation_id].append({
        "role": "user",
        "content": message
    })
    
    # CUSTOMIZE: Your stateful logic here
    history = conversation_history[conversation_id]
    message_count = len(history)
    
    # Example: Count-based responses
    if message_count == 1:
        response = "Hello! This is our first message. What's your name?"
    elif message_count == 2:
        response = f"Nice to meet you! You said: {history[0]['content']}"
    else:
        response = f"This is message #{message_count}. Previous: {history[-2]['content']}"
    
    # Save agent response to history
    conversation_history[conversation_id].append({
        "role": "assistant",
        "content": response
    })
    
    return response

# ============================================
# DO NOT MODIFY BELOW
# ============================================
if __name__ == "__main__":
    port = int(os.getenv("PORT", "7000"))
    
    if os.getenv("ENABLE_TUNNEL", "false").lower() == "true":
        ngrok.set_auth_token(os.getenv("NGROK_AUTH_TOKEN"))
        tunnel = ngrok.connect(port, bind_tls=True)
        public_url = tunnel.public_url
        print(f"🌐 Tunnel URL: {public_url}")
    else:
        public_url = os.getenv("PUBLIC_URL", f"http://localhost:{port}")
    
    nanda = NANDA(
        agent_id=os.getenv("AGENT_ID"),
        agent_logic=agent_logic,
        port=port,
        public_url=public_url,
        registry_url=os.getenv("REGISTRY_URL"),
        enable_telemetry=True
    )
    
    print(f"🤖 Stateful Agent '{os.getenv('AGENT_ID')}' ready!")
    nanda.start()`}
                </pre>
              </div>

              <p style={{ fontSize: '0.813rem', color: '#ccc' }}>
                Full examples: <a 
                  href="https://github.com/projnanda/NEST/tree/main/examples"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: '#dc2626', textDecoration: 'underline' }}
                >
                  NEST Examples
                </a>
              </p>
            </section>

            <section style={{ marginBottom: '30px' }}>
              <h2 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#fff', marginBottom: '12px' }}>
                Deploy with Ngrok Tunnel
              </h2>

              <p style={{ fontSize: '0.813rem', color: '#ccc', marginBottom: '12px' }}>
                Ngrok creates a secure tunnel from the internet to your local machine.
              </p>

              <p style={{ fontSize: '0.875rem', fontWeight: '600', color: '#fff', marginBottom: '8px' }}>
                How It Works:
              </p>
              <ol style={{ fontSize: '0.813rem', color: '#ccc', marginBottom: '16px', paddingLeft: '20px' }}>
                <li>Agent starts on localhost:7000</li>
                <li>Ngrok creates tunnel: https://abc123.ngrok.io → localhost:7000</li>
                <li>Agent registers public URL with NANDA</li>
                <li>Other agents can communicate via tunnel</li>
              </ol>

              <p style={{ fontSize: '0.875rem', fontWeight: '600', color: '#fff', marginBottom: '8px' }}>
                Basic Setup:
              </p>
              <pre style={{
                background: '#111',
                padding: '12px',
                borderRadius: '4px',
                overflow: 'auto',
                fontSize: '0.688rem',
                color: '#ccc',
                fontFamily: 'monospace',
                lineHeight: '1.4',
                marginBottom: '16px'
              }}>
{`from python_a2a import A2AServer

def handle_message(message, conversation_id):
    return f"Echo: {message}"

A2AServer(
    agent_id="my-test-agent",
    handler=handle_message,
    port=7000,
    enable_tunnel=True
).start()`}
              </pre>

              <p style={{ fontSize: '0.875rem', fontWeight: '600', color: '#fff', marginBottom: '8px' }}>
                Start Agent:
              </p>
              <pre style={{
                background: '#111',
                padding: '12px',
                borderRadius: '4px',
                overflow: 'auto',
                fontSize: '0.688rem',
                color: '#ccc',
                fontFamily: 'monospace',
                lineHeight: '1.4',
                marginBottom: '16px'
              }}>
{`python agent.py

# Output:
# Agent 'my-test-agent' starting...
# Port: 7000
# Creating ngrok tunnel...
# Tunnel URL: https://abc123.ngrok.io
# Registered with NANDA
# Agent ready!`}
              </pre>

              <p style={{ fontSize: '0.875rem', fontWeight: '600', color: '#fff', marginBottom: '8px' }}>
                Test:
              </p>
              <pre style={{
                background: '#111',
                padding: '12px',
                borderRadius: '4px',
                overflow: 'auto',
                fontSize: '0.688rem',
                color: '#ccc',
                fontFamily: 'monospace',
                lineHeight: '1.4'
              }}>
{`curl -X POST https://abc123.ngrok.io/a2a \\
  -H "Content-Type: application/json" \\
  -d '{
    "role": "user",
    "content": {"type": "text", "text": "Hello!"},
    "conversation_id": "test-123"
  }'`}
              </pre>
            </section>
          </>
        )}

        {/* SHARED SECTION: Testing */}
        <section style={{ marginBottom: '30px', borderTop: '1px solid #333', paddingTop: '20px' }}>
          <h2 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#fff', marginBottom: '12px' }}>
            Testing Your Agent
          </h2>

          <p style={{ fontSize: '0.875rem', fontWeight: '600', color: '#fff', marginBottom: '8px' }}>
            1. Test Basic A2A Communication:
          </p>
          <pre style={{
            background: '#111',
            padding: '12px',
            borderRadius: '4px',
            overflow: 'auto',
            fontSize: '0.688rem',
            color: '#ccc',
            fontFamily: 'monospace',
            lineHeight: '1.4',
            marginBottom: '16px'
          }}>
{`curl -X POST http://YOUR_AGENT_IP:PORT/a2a \\
  -H "Content-Type: application/json" \\
  -d '{
    "role": "user",
    "content": {
      "type": "text",
      "text": "Hello, are you online?"
    },
    "conversation_id": "test-123"
  }'`}
          </pre>

          <p style={{ fontSize: '0.875rem', fontWeight: '600', color: '#fff', marginBottom: '8px' }}>
            2. Test Agent-to-Agent Communication:
          </p>
          <pre style={{
            background: '#111',
            padding: '12px',
            borderRadius: '4px',
            overflow: 'auto',
            fontSize: '0.688rem',
            color: '#ccc',
            fontFamily: 'monospace',
            lineHeight: '1.4',
            marginBottom: '16px'
          }}>
{`curl -X POST http://YOUR_AGENT_IP:PORT/a2a \\
  -H "Content-Type: application/json" \\
  -d '{
    "role": "user",
    "content": {
      "type": "text",
      "text": "@other-agent-id What's your specialty?"
    },
    "conversation_id": "a2a-test-123"
  }'`}
          </pre>

          <p style={{ fontSize: '0.875rem', fontWeight: '600', color: '#fff', marginBottom: '8px' }}>
            3. Verify Registry Registration:
          </p>
          <p style={{ fontSize: '0.813rem', color: '#ccc', marginBottom: '8px' }}>
            Check: <a href="/agents" style={{ color: '#dc2626', textDecoration: 'underline' }}>View All Agents</a>
          </p>
          <pre style={{
            background: '#111',
            padding: '12px',
            borderRadius: '4px',
            overflow: 'auto',
            fontSize: '0.688rem',
            color: '#ccc',
            fontFamily: 'monospace',
            lineHeight: '1.4'
          }}>
{`# Search for your agent
curl "https://nest.projectnanda.org/api/agents/search?q=your-agent-id"

# Get specific agent details
curl "https://nest.projectnanda.org/api/agents/your-agent-id"`}
          </pre>
        </section>

      </div>
    </div>
  );
};

export default Deploy;
